import React, { useState } from 'react';

import { Box, Menu, MenuItem, MenuList, Paper } from '@mui/material';
import { StatusChip, StatusBlueIcon } from '@components';
import { Text } from 'components/common/ui';
import { styles } from './setStatus.style';

const STATUSES = ['Pending', 'In Progress', 'Done'];

const SetStatus = ({ onSetStatus }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleClick = (status) => {
    if (onSetStatus) {
      onSetStatus(status);
    }
    handleMenuClose();
  };

  return (
    <>
      <Box sx={styles.wrapper} onClick={handleOpenMenu}>
        <StatusBlueIcon />
        <Text sx={styles.text}>Set Status</Text>
      </Box>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        sx={styles.menu}
      >
        <Paper sx={styles.paper}>
          <MenuList sx={styles.menuList}>
            {STATUSES?.map((item, index) => {
              return (
                <MenuItem
                  // eslint-disable-next-line react/no-array-index-key
                  key={`status-${index}`}
                  disabled={item?.disabled}
                  onClick={() => handleClick(item)}
                  sx={styles.menuItem}
                >
                  <StatusChip status={item} />
                </MenuItem>
              );
            })}
          </MenuList>
        </Paper>
      </Menu>
    </>
  );
};

export default SetStatus;
